"use strict";

var _moduleLocalization = require("@eig-builder/module-localization");

_moduleLocalization.Localizations.append({
  core: {
    components: {
      datatable: {
        searchFilter: {
          title2: 'Search',
          placeholder: 'Search'
        },
        table: {
          items: '{0} items',
          previous: 'Previous',
          next: 'Next'
        },
        columnSelector: {
          title: 'Edit columns',
          primaryBtn: 'Apply',
          cancelBtn: 'Cancel',
          subTitle: 'Choose which columns you want to see'
        },
        exportWindow: {
          title: 'Export data',
          primaryBtn: 'Export',
          cancelBtn: 'Cancel',
          subtitle: 'Choose which columns you want to export',
          renderExportSortOptionTitle: 'How do you want to sort your data?',
          range: 'Range',
          noDataTitle: 'No Data found',
          noDataContent: 'The current selection has no data'
        },
        filter: {
          clear: 'Clear all filters',
          title: 'Choose which items to display',
          not: 'Not'
        },
        multipleSelect: {
          title: '{0} selected',
          "delete": 'Delete',
          deleteTitle: 'Delete these items?',
          deleteContent: 'Are you sure you want to delete these items?',
          remove: 'Remove from category',
          thisProduct: 'this product',
          theseProducts: 'these products',
          subCategory: 'and all of its subcategories',
          categoryTitle: 'Remove {0} from the products category',
          categoryContent: 'Are you sure you want to remove {0} from the products category {2}',
          moveto: 'Move to page',
          moveToBottom: 'Move to Bottom',
          moveToTop: 'Move to Top'
        }
      }
    }
  }
});